import api from '~api'

export const url = `/ucan`

export async function getUCAN () {
  const {
    data
  } = await api.get(`${url}`)

  return {
    ucan_link: data.data.link
  }
}
